/**
 * Client-only bootstrap: Sentry init + Service Worker registration.
 * Called from a useEffect inside RootComponent so it runs only in the browser.
 *
 * P5 — Sentry é importado DINAMICAMENTE e agendado em idle. Antes um
 * `import * as Sentry` estático arrastava ~70KB gzipped para o bundle
 * principal em toda visita. Agora o boot ganha esses KB de volta e o
 * parse do JS crítico cai — grande impacto em FCP/TBT mobile.
 */

let bootstrapped = false;

export function bootstrapClient() {
  if (bootstrapped || typeof window === "undefined") return;
  bootstrapped = true;

  const schedule = (cb: () => void) => {
    const w = window as unknown as {
      requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => void;
    };
    if (typeof w.requestIdleCallback === "function") {
      w.requestIdleCallback(cb, { timeout: 3000 });
    } else {
      setTimeout(cb, 2000);
    }
  };

  schedule(() => {
    if (!import.meta.env.PROD) return;
    void import("@sentry/react").then((Sentry) => {
      const shouldSampleReplay =
        window.innerWidth > 768 && Math.random() < 0.02;
      Sentry.init({
        dsn: import.meta.env.VITE_SENTRY_DSN,
        integrations: [
          Sentry.browserTracingIntegration(),
          ...(shouldSampleReplay
            ? [
                Sentry.replayIntegration({
                  maskAllText: false,
                  blockAllMedia: false,
                }),
              ]
            : []),
        ],
        tracesSampleRate: 0.1,
        replaysSessionSampleRate: shouldSampleReplay ? 1.0 : 0,
        replaysOnErrorSampleRate: 1.0,
        environment: import.meta.env.MODE,
        enabled: true,
      });
    });
  });

  if ("serviceWorker" in navigator && import.meta.env.PROD) {
    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register("/sw.js")
        .then((registration) => {
          console.log("SW registered:", registration.scope);
        })
        .catch((error) => {
          console.log("SW registration failed:", error);
        });
    });
  }
}
